export default __webpack_public_path__ + "static/media/pepperoni.a4d7705b.svg";